import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Slider from 'react-slick';
import style from '../../../../../packs/slick_carousel_style';

import ArticleCard from '../../DashboardArticles';
import { OrganizationCard } from '../../cards/OrganizationCard';

const ListScreen = ({
	followList,
	setShowList,
	setCurrentId,
	setModalState,
	formDispatch,
}) => {
	const [popUpState, setPopUpState] = useState(false);

	const deleteButton = () => {
		setCurrentId(followList.id);
		setModalState('delete');
		setPopUpState(false);
	};

	const editButton = () => {
		setCurrentId(followList.id);
		setModalState('edit');
		formDispatch({ type: 'FILL', payload: { name: followList.name } });
		setPopUpState(false);
	};

	if (!followList) {
		return null;
	}

	return (
		<div id="list-screen">
			<div className="link" onClick={() => setShowList(null)}>
				&#10216; Back to following
			</div>

			<div className="title-container">
				<div className="row">
					<div className="column small-12">
						<h3 className="follows-name">{followList.name}</h3>
						<div
							className="gear-icon"
							onClick={() => setPopUpState(!popUpState)}
						>
							<div style={{ position: 'relative' }}>
								<FontAwesomeIcon icon={faCog} size="2x" />
								<div
									className={
										'pop-up' + (popUpState ? ' active' : '')
									}
								>
									<div
										className="pop-up-section bottom-border"
										onClick={editButton}
									>
										Edit list
									</div>
									<div
										className="pop-up-section"
										onClick={deleteButton}
									>
										Delete list
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="content-section">
				{followList.organizations && followList.organizations.length ? (
					<div className="organization-section">
						<div className="row">
							<div className="column small-12">
								<h4>Organizations</h4>
							</div>
							<div className="columns small-12 carousel-container">
								<Slider {...style} className="slick-carousel">
									{followList.organizations.map(
										(orgData, index) => {
											return (
												<OrganizationCard
													orgData={orgData}
													key={index}
													params=""
												/>
											);
										}
									)}
								</Slider>
							</div>
						</div>
					</div>
				) : null}

				{followList.articles && followList.articles.length ? (
					<div className="article-section">
						<div className="row">
							<div className="column small-12">
								<h4>Articles</h4>
							</div>
							<div className="columns small-12 carousel-container">
								<Slider {...style} className="slick-carousel">
									{followList.articles.map(
										(articleData, index) => {
											return (
												<ArticleCard
													articleData={articleData}
													key={index}
												/>
											);
										}
									)}
								</Slider>
							</div>
						</div>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default ListScreen;
